@use "sass:math";
@use "~theme/typography";
@use "~theme/breakpoints";

$choices-width: 440px;

.divider {
  display: none;

  @include breakpoints.desktop {
    @include typography.heading3;
    display: block;
    padding-bottom: 12px;
    margin: 0 0 12px;
    border: none;
    border-bottom: 4px solid var(--blue-01);
    max-width: 16em;
  }
}

.overlay {
  flex: 1; // ensures component stretches to fill the screen verticall
}

.prompt {
  margin-bottom: 40px;

  @include breakpoints.desktop {
    max-width: 370px;
    grid-area: prompt;
  }
}

.headline {
  @include typography.heading3;
  margin: 0;
}

.yourAnswer {
  @include typography.body;

  @include breakpoints.desktop {
    padding-top: 4px;
    padding-bottom: 28px;
  }
}

.bg {
  @include breakpoints.desktop {
    grid-area: bg;
    background: no-repeat center/cover url("~images/people.jpg");
    overflow: hidden;
    position: relative;
  }
}

// This pseudoelement is the triangular area that partially covers the bg image
.bg::after {
  @include breakpoints.desktop {
    $rotate-amount: 13deg;
    content: "";
    position: absolute;
    bottom: 0;
    right: 100%;
    width: 100%;
    height: math.div(100%, math.sin(90deg - $rotate-amount)); // stretch the diagonal area so it has the right height.
    background-color: var(--gray-04);
    transform-origin: bottom right;
    transform: rotate($rotate-amount);
  }
}

.layout {
  display: grid;
  padding: 20px var(--mobile-gutter);
  flex-grow: 1;

  @include breakpoints.desktop {
    height: 100%;
    padding: 0;
    grid-template-columns: var(--desktop-gutter) 1fr $choices-width 1fr var(--desktop-gutter);
    grid-template-rows: 48px 1fr 48px;
    grid-template-areas:
      ". .      .       bg bg"
      ". prompt choices bg bg"
      ". .      .       bg bg";
  }
}

.iWearGrid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  max-width: $choices-width;
  margin: auto;

  @include breakpoints.tablet {
    grid-template-columns: 1fr 1fr;
  }

  @include breakpoints.desktop {
    grid-area: choices;
    padding: 0 40px;
  }
}

.interrogative {
  @include typography.body-semibold;
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.qualifier {
  text-align: center;
  padding-bottom: 20px;
  margin: 0;
}

.button {
  flex: 1;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
}

.buttons {
  display: flex;
  flex-direction: row;
}
